/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import {
  HAS_ASSET,
  HAS_ASSET_SUCCESS,
  HAS_ASSET_FAILURE,
} from "../actions/asset/assetActionTypes";

import { RESET_HAS_ASSET } from "../actions/actionTypes";

import {
  setLoadingState,
  setSuccessResponse,
  setErrorResponse,
} from "./reducerUtils";

const initialState = {
  asset: {
    data: [],
    state: "INIT",
    error: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case HAS_ASSET:
      return setLoadingState(state, "asset");
    case HAS_ASSET_SUCCESS:
      return setSuccessResponse(state, action, "asset");
    case HAS_ASSET_FAILURE:
      return setErrorResponse(state, action.errResp, "asset");

    case RESET_HAS_ASSET:
      return setLoadingState(state, "asset");
    default:
      return state;
  }
}
